/*
 * Components Core JS
 *
 * @author				Matt Gifford
 * @copyright			2020 Brigada Limited
 */
define("brigada/components", [], () => {
	/*
	 * @private	The private reference to this class
	 */
	const _this = {
		exports: []
	};


	/**
	 * Init
	 *
	 * @param        exports        The array of components
	 * @return        void
	 */
	_this.init = exports => {
		_this.exports = exports;
		_this.initComponents();

		// Add support for WordPress block editor
		if (!!document.body.classList.contains('block-editor-page') && !!window.acf) {
			for (let name of exports) {
				window.acf.addAction(`render_block_preview/type=${name}`, function () {
					_this.initComponents();
				});
			}
		}
	};


	/**
	 * Initializes components as required
	 *
	 * @return        void
	 */
	_this.initComponents = function () {
		// Loop through the components and initialise them
		const components = document.getElementsByClassName('component');

		for (let component of components) {
			// Loop through the class names on each component
			let classNames = component.className.split(' ');

			for (let className of classNames) {
				// Get the clean class name
				const name = className.replace(/^component-/, '').toLowerCase();

				// Skip if there's no helper for this component
				if (_this.exports.indexOf(name) === -1) {
					continue;
				}

				// Check if nodes of this component type need to be initialised
				const nodes = document.querySelectorAll(`.${className}:not([data-component-init="1"])`);
				if (nodes.length) {
					// Call the component helper class
					require([`site/components/${name}`], (componentClass) => {
						console.log(`site/components/${name} (${nodes.length})`);

						// Initialise
						componentClass.init(nodes);
					});

					// Mark as initialised
					for (let node of nodes) {
						node.setAttribute('data-component-init', '1');
					}
				}
			}
		}
	};


	// Return the object
	return _this;
});